import firebase from "firebase";
import { useState, useEffect, useRef } from "react";
import { useCollectionData } from "react-firebase-hooks/firestore";

const Message = (props) => {
  const { Text, SendersName, Sender, Recepient } = props.message;
  const userPhone = parseInt(localStorage.getItem("user-phone"), 10);
  const messageClass = Sender === userPhone ? "sent" : "received";
  return (
    <div className={`message ${messageClass}  flex-start`}>
      <li>{Text}</li>
    </div>
  );
};

const Chatroom = () => {
  const [text, setText] = useState("");
  const firestore = firebase.firestore();
  const sender = parseInt(localStorage.getItem("user-phone"), 10);
  const recepient = parseInt(localStorage.getItem("person-phone"), 10);
  const [recepientInfo, setRecepientInfo] = useState({
    name: "amBeat",
    dp: "https://firebasestorage.googleapis.com/v0/b/am-beats-94d37.appspot.com/o/dev%2F1.jpg?alt=media&token=57e265d4-2af3-4af3-a614-20e36c4b9ddd",
  });
  const messagesRef = firestore
    .collection(`users/${sender}/chats/${recepient}/chat`)
    .orderBy("createdAt");
  const [messages] = useCollectionData(messagesRef, { idField: "id" });
  const dummy = useRef();

  useEffect(() => {
    function getRecepientData() {
      const ref = firestore.doc(`users/${recepient}`);
      ref.get().then((snap) => {
        const info = {
          name: snap.data().name,
          phone: snap.data().phone,
          dp: snap.data().dp,
        };

        const chatFace = firestore.doc(`users/${sender}/chats/${recepient}/`);
        chatFace.set(info);

        setRecepientInfo(info);
      });
    }

    function getSenderData() {
      const ref = firestore.doc(`users/${sender}`);
      ref.get().then((snap) => {
        const info = {
          name: snap.data().name,
          phone: snap.data().phone,
          dp: snap.data().dp,
        };

        const chatFace = firestore.doc(`users/${recepient}/chats/${sender}`);
        chatFace.set(info);
      });
    }

    function checkChat() {
      const senderRef = firestore.doc(`users/${sender}/chats/${recepient}`);
      const rcpRef = firestore.doc(`users/${recepient}/chats/${sender}`);

      senderRef
        .get()
        .then((snap) => {
          if (!snap.data()) {
            getRecepientData();
          } else {
          }
        })
        .catch();

      rcpRef
        .get()
        .then((snap) => {
          if (!snap.data()) {
            getSenderData();
          } else {
          }
        })
        .catch();
    }

    function getRecepientDetails() {
      const ref = firestore.doc(`users/${recepient}`);
      ref.get().then((snap) => {
        const info = {
          name: snap.data().name,
          phone: snap.data().phone,
          dp: snap.data().dp,
        };

        setRecepientInfo(info);
      });
    }

    checkChat();
    getRecepientDetails()
  }, []);

  function sendText() {
    const senderUrl = firestore.collection(
      `users/${sender}/chats/${recepient}/chat`
    );
    const recepientUrl = firestore.collection(
      `users/${recepient}/chats/${sender}/chat`
    );

    const theText = {
      Sender: sender,
      SendersName: localStorage.getItem("user-name"),
      Recepient: recepient,
      Text: text,
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
    };

    const senderFace = firestore.doc(`users/${sender}/chats/${recepient}`);
    const recepientFace = firestore.doc(`users/${recepient}/chats/${sender}`);

    senderFace.update({
      lastText: text,
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
    });

    recepientFace.update({
      lastText: text,
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
    });

    setText("");
    senderUrl.add(theText);
    recepientUrl.add(theText);
    dummy.current.scrollIntoView({ behavior: "smooth" });
  }

  return (
    <div className="chat-room">
      <header className="flex-start">
        <img src={recepientInfo.dp} />
        <div className="recp-info flex-start">
          <span>{recepientInfo.name}</span>
        </div>
      </header>
      <section className="flex-col-start-left overflow-y">
        {messages &&
          messages.map((a) => {
            return <Message key={Math.random()} message={a} />;
          })}
        <div ref={dummy}></div>
      </section>
      <footer className="flex-start">
        <input
          value={text}
          type="text"
          placeholder="Text Message"
          onChange={(e) => {
            setText(e.target.value);
          }}
        />
        <span
          onClick={(e) => {
            sendText();
          }}
        >
          Send
        </span>
      </footer>
    </div>
  );
};

export default Chatroom;
